import moment from 'moment'

export const manageDates = {
  data () {
    return {
      toggleAction: null,
      queryDateStart: moment().subtract(7, 'days').startOf('day'),
      queryDateEnd: moment().subtract(1, 'days').endOf('day')
    }
  },
  computed: {
    disableToggle () {
      var today = moment.utc().endOf('day')
      if (moment(this.queryDateEnd).isSame(today, 'day')) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleWeekleft () {
      var minusWeek = moment.utc(this.queryDateStart).subtract(7, 'days').endOf('day')
      if (moment(minusWeek).isBefore('2019-01-01')) {
        this.queryDateStart = moment('2019-01-01').startOf('day')
        this.queryDateEnd = moment('2019-01-01').add(7, 'days').endOf('day')
      } else {
        this.queryDateStart = moment(this.queryDateStart).subtract(7, 'days').startOf('day')
        this.queryDateEnd = moment(this.queryDateEnd).subtract(7, 'days').endOf('day')
      }
      if (this.toggleAction) {
        this.toggleAction()
      }
    },
    toggleWeekRight () {
      var today = moment.utc().endOf('day')
      var plusWeek = moment.utc(this.queryDateEnd).add(7, 'days').endOf('day')
      if (moment(plusWeek).isAfter(today)) {
        this.queryDateStart = moment().subtract(6, 'days').startOf('day')
        this.queryDateEnd = moment().endOf('day')
      } else {
        this.queryDateStart = moment(this.queryDateStart).add(7, 'days').startOf('day')
        this.queryDateEnd = moment(this.queryDateEnd).add(7, 'days').endOf('day')
      }
      if (this.toggleAction) {
        this.toggleAction()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/manageDates.js